import React from 'react';

import { ContainerCall } from '@/features/method-tester/types/SDKCallResult';
import { useIsMobileScreen } from '@/hooks';
import { Button } from '@asphalt-react/button';
import { Cross } from '@asphalt-react/iconpack';

declare global {
  interface Window {
    WindVane?: {
      call: ContainerCall;
    };
    gopayContainer?: {
      call: ContainerCall;
    };
    flutter_inappwebview?: unknown;
    webkit?: {
      messageHandlers?: {
        gpContainer?: unknown;
        [key: string]: unknown;
      };
    };
    Android?: unknown;
    snap?: {
      pay?: (
        token: string,
        options?: {
          onSuccess?: (result: unknown) => void;
          onPending?: (result: unknown) => void;
          onError?: (error: unknown) => void;
          onClose?: () => void;
        }
      ) => void;
      show?: () => void;
      hide?: () => void;
    };
  }
}

const MobileCloseHeader: React.FC = () => {
  const isMobileScreen = useIsMobileScreen();
  const isFlutterInAppWebView = !!window?.flutter_inappwebview;
  const isIOSWebkit = !!window?.webkit?.messageHandlers?.gpContainer;
  const isAndroid = !!window?.Android;

  const shouldShowCloseButton =
    isMobileScreen && !(isFlutterInAppWebView || isIOSWebkit || isAndroid);

  const handleCloseButtonClick = () => {
    const container = window.gopayContainer || window.WindVane;
    if (container) {
      container.call(
        'WVNavigator',
        'pop',
        {},
        () => {},
        () => {}
      );
    }
  };

  if (!shouldShowCloseButton) return null;

  return (
    <div className="bg-gray-100 top-0 left-0 w-full pt-5 flex items-center px-2">
      <Button system icon nude size="l" onClick={handleCloseButtonClick}>
        <Cross />
      </Button>
    </div>
  );
};

export default MobileCloseHeader;
